(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PeopleFranchiserFormController', PeopleFranchiserFormController)

    /** @ngInject */
    function PeopleFranchiserFormController($q, $rootScope, $state, $stateParams, LoadingHelper, PersonService, AuthenticationService,
        UtilHelper, sweetAlert, ResponsibilityService, PermissionGroupService,ImagePathHelper, DEFAULT_IDENTIFIERS) {
        const vm = this;
        const personId = $stateParams.personId;
        let allResponsibilities;
        let allPermissionGroups;

        vm.saveUser = () => {
            LoadingHelper.startLoading('.loading-holder');

            let personData = {
                Id: vm.personData.Id,
                Name: vm.personData.Name,
                GenderId: vm.selectedGender.Id,
                BirthDate: UtilHelper.convertToMomentDate(vm.personData.BirthDateFormatted).format('YYYY-MM-DD')
            }

            if (!vm.personData.PersonDocuments.find(x => x.DocumentTypeId == 1)) {
                sweetAlert.swal({
                    title: 'OPS!',
                    text: 'Você também deve informar o CPF da pessoa no cadastro.',
                    type: 'warning',
                    confirmButtonText: 'Ok',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                })

                LoadingHelper.stopLoading('.loading-holder');
                return;
            }

            personData.PersonDocuments = vm.personData.PersonDocuments;
            personData.PersonEmails = vm.personData.PersonEmails;
            personData.PersonPhones = vm.personData.PersonPhones;

            PersonService
                .put(personData)
                .then(() => {
                    UtilHelper.successCallback('update');
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        vm.updateUserAssociations = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa ação irá alterar a associação da pessoa com as permissões selecionadas!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value)
                    updateUserAssociations(vm.personData.PersonCompanies);
            })
        }

        vm.removeAssociation = personCompany => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Você irá remover a associação da pessoa com essa empresa, ela não poderá mais visualizar os dados!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    personCompany.Block = true;

                    deleteCompanyAssociation(personCompany);
                }
            })
        }

        vm.onChangePersonCompanyPermissionGroup = personCompany => {
            // If is franchisee permission group
            if (personCompany.PermissionGroupId == 3)
                personCompany.ResponsibilityId = 4;
        }

        vm.isLoggedPersonCurrentCompany = companyId => {
            if (vm.loggedUserData.PermissionGroup.Id == 1)
                return true;

            return ($rootScope.canUserEdit) && (companyId == vm.loggedUserData.CompanyId);
        }

        vm.getResponsibilities = personCompany => {
            if (personCompany.PermissionGroupId == 3)
                return allResponsibilities.filter(resp => resp.Id == 4);

            return allResponsibilities.filter(resp => resp.Id != 4);
        }

        vm.getPermissionGroups = company => {
            if (!company.CompanyIdParent)
                return allPermissionGroups.filter(x => x.Id == 1 || x.Id == 2 || x.Id == 5 || x.Id == 6);

            return allPermissionGroups.filter(x => x.Id == 3 || x.Id == 4);
        }

        vm.changeTab = tabId => {
            vm.selectedTab = tabId;
        }

        init();

        function updateUserAssociations(personCompanyData) {
            LoadingHelper.startLoading('.loading-holder');

            let personCompanyFinal = personCompanyData
                .filter(personDataCompany => (vm.isLoggedPersonCurrentCompany(personDataCompany.CompanyId)))
                .reduce((acc, cur) => {
                    let associationData = {
                        CompanyId: cur.CompanyId,
                        PersonId: vm.personData.Id,
                        ResponsibilityId: cur.ResponsibilityId,
                        PermissionGroupId: cur.PermissionGroupId,
                        Block: cur.Block,
                        Id: cur.Id
                    };

                    // If the logged user is an adminstrator let him choose the permission group of the found person
                    if (vm.loggedUserData.PermissionGroup.Id == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISER_ADMINISTRATOR) {
                        associationData.PermissionGroupId = cur.PermissionGroupId;
                    }

                    // If he hasn't set the permission group set as franchiser worker by default
                    else {
                        associationData.PermissionGroupId = cur.ResponsibilityId != 4 ? DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE_WORKER : DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISEE;
                    }

                    acc.push(associationData);

                    return acc;
                }, []);

            PersonService
                .updateCompanyAssociation(personCompanyFinal)
                .then(() => {
                    UtilHelper.successCallback('update');
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        function deleteCompanyAssociation(personCompany) {
            LoadingHelper.startLoading('.loading-holder');

            PersonService
                .deleteCompanyAssociation(personCompany.PersonId, personCompany.CompanyId)
                .then(() => {
                    vm.personData.PersonCompanies = vm.personData.PersonCompanies.filter(pc => (pc.CompanyId != personCompany.CompanyId));

                    UtilHelper.successCallback('delete');
                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.loading-holder');
                })
        }

        function getPerson() {
            if (!personId) {
                sweetAlert.swal({
                    title: 'Não foi possível recuperar os dados da pessoa!',
                    text: 'Ocorreu um erro ao buscar o identificador da pessoa',
                    type: 'warning',
                    confirmButtonText: 'Ir para Home',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(response => {
                    if (response.value) {
                        LoadingHelper.stopLoading('.loading-holder');

                        $state.go('app.home');
                    }
                })

                return;
            }

            PersonService
                .get(personId)
                .then(success => {
                    if (success.RegistrationDate)
                        success.RegistrationDateFormatted = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
                    else
                        success.RegistrationDateFormatted = '-';

                    if (success.BirthDate)
                        success.BirthDateFormatted = moment(success.BirthDate).format('DD/MM/YYYY');
                    else
                        success.BirthDateFormatted = '-';

                    vm.personData = success;

                    if (vm.personData.GenderId)
                        vm.selectedGender = vm.genders.find(gender => (gender.Id == vm.personData.GenderId));

                    if (vm.personData.Image) {
                        vm.mainImageData.image = vm.personData.Image;
                        vm.mainImageData.display = ImagePathHelper.imageResizePath('person', vm.personData.Id, vm.personData.Image, 150, 150);
                    }

                    LoadingHelper.stopLoading('.loading-holder');
                }, error => {
                    LoadingHelper.stopLoading('.loading-holder');
                    UtilHelper.errorCallback(error);
                })
        }

        function getGenders() {
            return PersonService
                .getGenders()
                .then(success => {
                    vm.genders = success;
                }, error => {
                    UtilHelper.errorCallback(error);
                })
        }

        function getResponsibilities() {
            return ResponsibilityService
                .getAll()
                .then(success => allResponsibilities = success.Registers,
                    error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.company-permission-listing');
                    });
        }

        function getPermissionGroups() {
            return PermissionGroupService
                .getAll()
                .then(success => allPermissionGroups = success.Registers,
                    error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.loading-holder');
                    });
        }

        function initVars() {
            vm.loggedUserData = AuthenticationService.getUser();

            if (personId == vm.loggedUserData.PersonId) {
                $state.go('app.my-profile');
                return;
            }

            vm.personAssociationHistory = [];
            vm.selectedTab = 1;

            vm.mainImageData = {
                display: '',
                image: ''
            }
        }

        function init() {
            initVars();

            LoadingHelper.startLoading('.loading-holder');

            $q.all([getGenders(), getResponsibilities(), getPermissionGroups()])
                .then(() => {
                    getPerson();
                })
        }
    }
}());